import { Table } from '@wyz/ui';
import clsx from 'clsx';
// eslint-disable-next-line @wyz/module/no-relative-import
import './table.scss';

type Props = React.PropsWithChildren<{ className?: string }>;

function PurchaseTable({ children, className }: Props) {
  return (
    <Table
      className={clsx('product-table', className)}
      style={{ tableLayout: 'fixed' }}
    >
      {children}
    </Table>
  );
}

export default PurchaseTable;
